export default "__VITE_ASSET__CWcefxe8__";